import gql from 'graphql-tag';

export default gql`
mutation($show: Boolean!) {
  setShowHeader(show: $show) @client
}
`;
